import BorderCardList from 'src/component/common/layout/BorderCardList';
import PeriodBorderGraphCard from 'src/component/screen/periodbordergraph/PeriodBorderGraphCard';

export function PeriodBorderGraphScreen(): JSX.Element {
  return <BorderCardList card={PeriodBorderGraphCard} />;
}
